import request from 'superagent';
let timeout = 10000;

/*
* factory function for Ajax request
* @return Promise
* @param string - HTTP method
* @param string - url
* @param object - data for send
*/

function makeCall(method, url, data = {}) {
  let req = request[method](url)
    .set('Accept', 'application/json')
    .timeout(timeout);

  if (method === 'get') {
    //req.type('json')
      req.query(data);
  } else {
    req.type('form');
    req.send(data);
  }

  return new Promise(function (resolve, reject) {
    req.end(function (err, res) {
      if (err) {
        reject(err);
      } else if (res.status === 400) {
        reject(err);
      } else if (!res.ok) {
        reject(err);
      } else {
        resolve(res.body);
      }
    });
  });
}


export default {
    get(url, data) {
      return makeCall('get', url, data);
    },

    post(url, data) {
      return makeCall('post', url, data);
    },

    put(url, data) {
      return makeCall('put', url, data);
    },

    patch(url, data) {
      return makeCall('patch', url, data);
    },

    delete(url, data) {
      return makeCall('del', url, data);
    }
};

